// @flow
import type {
  AuthState,
  RequestResetPasswordOperation,
} from 'hfty-auth/types'

import type {
  Action,
} from 'fc-flow-types/redux'

// Redux
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'

// Selectors, Action Creators, Operator
import { requestResetPassword } from 'fc-auth'
import { requestResetOperation$, requestResetOperator } from 'hfty-auth'

// Operator
type Props = {
  resetRequestOperation: ?RequestResetPasswordOperation,
}

type Actions = {
  actions: {
    requestResetPassword: typeof login,
  }
}

function onChange (operation: RequestResetPasswordOperation): Action<RequestResetPasswordOperation> {
  const action = requestResetOperator().actionCreators.updateOperation(operation)

  return {
    ...action,
    error: null,
    meta: null,
  }
}

const mapStateToProps = function<S: { auth: AuthState }> (state: S): Props {
  return {
    operation: requestResetOperation$(state),
  }
}

const mapDispatchToProps = function (dispatch: Dispatch<*>): Actions {
  return {
    actions: bindActionCreators({
      onSubmit: requestResetPassword,
      onChange,
    }, dispatch),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)
